import { render } from "./AgeExactRangeRadioButtons.vue?vue&type=template&id=4ab6c069&ts=true"
import script from "./AgeExactRangeRadioButtons.vue?vue&type=script&lang=ts"
export * from "./AgeExactRangeRadioButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../ss/MO/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__